module.exports = __webpack_public_path__ + "img/menu.195d13ec.svg";